// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.risk-measures[data-v-6f011747] {
  width: 100%;
}
.risk-measures table[data-v-6f011747] {
  table-layout: fixed;
}
.risk-measures .row-container[data-v-6f011747]:nth-child(9) {
  white-space: nowrap;
}
.row-container[data-v-6f011747] {
  height: 24px;
  border-bottom: 1px solid #ccc;
}
.align-right[data-v-6f011747] {
  text-align: right;
}
.align-left[data-v-6f011747] {
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/RiskMeasures.vue","webpack://./RiskMeasures.vue"],"names":[],"mappings":"AACA;EACC,WAAA;ACAD;ADDA;EAGE,mBAAA;ACCF;ADJA;EAME,mBAAA;ACCF;ADEA;EACC,YAAA;EACA,6BAAA;ACAD;ADEA;EACC,iBAAA;ACAD;ADEA;EACC,gBAAA;ACAD","sourcesContent":["\n.risk-measures {\n\twidth: 100%;\n\ttable {\n\t\ttable-layout: fixed;\n\t}\n\t.row-container:nth-child(9) {\n\t\twhite-space: nowrap;\n\t}\n}\n.row-container {\n\theight: 24px;\n\tborder-bottom: 1px solid #ccc;\n}\n.align-right {\n\ttext-align: right;\n}\n.align-left {\n\ttext-align: left;\n}\n",".risk-measures {\n  width: 100%;\n}\n.risk-measures table {\n  table-layout: fixed;\n}\n.risk-measures .row-container:nth-child(9) {\n  white-space: nowrap;\n}\n.row-container {\n  height: 24px;\n  border-bottom: 1px solid #ccc;\n}\n.align-right {\n  text-align: right;\n}\n.align-left {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
